import type { Task } from "~skillBuilder/utils/types";

import { title } from "../../contentBlocks";

export const AzMrtSkillCheck = {
  name: "Skill Check",
  uniqueName: "az-mrt-skill-check",
  icon: "BookmarkCheck",
  durationTimeText: "5 min",
  isQuiz: true,
  steps: [
    // Step 1
    {
      nextButtonText: "Start",
      prevButtonText: "Review",
      showPreviousButton: true,
      questions: [
        // Question 1.1
        {
          attribute: "az-mrt.skill-check/intro",
          label: "",
          answerType: {
            type: "CONTENT",
            value: "valid",
            markdown: `
${title({ text: "Skill Check", durationTimeText: "5 min" })}
<p>As substitute teachers, you play a vital role in protecting children. This knowledge check will assess your ability to recognize signs of abuse and neglect and understanding of your legal duty to report.</p>
`,
          },
        },
      ],
    },
    // Step 2
    {
      questions: [
        // Question 2.1
        {
          attribute: "az-mrt.skill-check/who",
          label: "Who in Arizona must report suspected child abuse/neglect?",
          answerType: {
            type: "RADIO",
            options: [
              { label: "Only principals", value: "invalid-1", isCorrect: false },
              { label: "Only doctors", value: "invalid-2", isCorrect: false },
              {
                label: "Mandated professionals, including teachers",
                value: "valid",
                isCorrect: true,
              },
              { label: "Only law enforcement", value: "invalid-3", isCorrect: false },
            ],
          },
        },
      ],
    },
    // Step 3
    {
      questions: [
        // Question 3.1
        {
          attribute: "az-mrt.skill-check/standard",
          label: "What is the standard for reporting?",
          answerType: {
            type: "RADIO",
            options: [
              { label: "Proof of abuse", value: "invalid-1", isCorrect: false },
              { label: "Reasonable belief", value: "valid", isCorrect: true },
              { label: "Child must disclose", value: "invalid-2", isCorrect: false },
              { label: "Another teacher must agree", value: "invalid-3", isCorrect: false },
            ],
          },
        },
      ],
    },
    // Step 4
    {
      questions: [
        // Question 4.1
        {
          attribute: "az-mrt.skill-check/when",
          label: "When should you report?",
          answerType: {
            type: "RADIO",
            options: [
              { label: "After investigating", value: "invalid-1", isCorrect: false },
              { label: "After consulting principal", value: "invalid-2", isCorrect: false },
              { label: "Immediately, with reasonable belief", value: "valid", isCorrect: true },
              { label: "Within 72 hours", value: "invalid-3", isCorrect: false },
            ],
          },
        },
      ],
    },
    // Step 5
    {
      questions: [
        // Question 5.1
        {
          attribute: "az-mrt.skill-check/where",
          label: "Where do you report suspected abuse?",
          answerType: {
            type: "RADIO",
            options: [
              { label: "School counselor", value: "invalid-1", isCorrect: false },
              { label: "Only the principal", value: "invalid-2", isCorrect: false },
              { label: "Department of Education", value: "invalid-3", isCorrect: false },
              { label: "Arizona DCS Hotline or law enforcement", value: "valid", isCorrect: true },
            ],
          },
        },
      ],
    },
    // Step 6
    {
      questions: [
        // Question 6.1
        {
          attribute: "az-mrt.skill-check/penalty",
          label: "What is the penalty for failing to report?",
          answerType: {
            type: "RADIO",
            options: [
              {
                label: "Class 1 misdemeanor; Class 6 felony if a reportable offense",
                value: "valid",
                isCorrect: true,
              },
              { label: "Written warning", value: "invalid-1", isCorrect: false },
              { label: "Civil fine only", value: "invalid-2", isCorrect: false },
              { label: "No penalty", value: "invalid-3", isCorrect: false },
            ],
          },
        },
      ],
    },
    // Step 7
    {
      questions: [
        // Question 7.1
        {
          attribute: "az-mrt.skill-check/protections",
          label: "What protections do reporters have?",
          answerType: {
            type: "RADIO",
            options: [
              { label: "None", value: "invalid-1", isCorrect: false },
              { label: "Only if abuse is confirmed", value: "invalid-2", isCorrect: false },
              {
                label: "Immunity from liability for good-faith reports",
                value: "valid",
                isCorrect: true,
              },
              { label: "Protection only if anonymous", value: "invalid-3", isCorrect: false },
            ],
          },
        },
      ],
    },
    // Step 8
    {
      questions: [
        // Question 8.1
        {
          attribute: "az-mrt.skill-check/what",
          label: "What should you do if a child discloses abuse?",
          answerType: {
            type: "RADIO",
            options: [
              { label: "Promise secrecy", value: "invalid-1", isCorrect: false },
              { label: "Investigate yourself", value: "invalid-2", isCorrect: false },
              { label: "Confront the abuser", value: "invalid-3", isCorrect: false },
              {
                label: "Stay calm, listen, reassure, document, report",
                value: "valid",
                isCorrect: true,
              },
            ],
          },
        },
      ],
    },
    // Step 9
    {
      nextButtonText: "Next Lesson",
      questions: [
        // Question 9.1
        {
          attribute: "az-mrt.skill-check/outro",
          label: "You’ve completed this lesson",
          answerType: {
            type: "CONTENT",
            value: "valid",
            markdown: `
Congratulations! You now have the knowledge and tools to fulfill your role as a mandated reporter. You’ll now see Mandated Reporter as a qualification on your profile.
`,
          },
        },
      ],
    },
  ],
} as const satisfies Task;
